import React from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

import { TRANSACTIONS } from './MOCKS';

import clockIcon from '../../../assets/clockIcon.png';
import moneyIcon from '../../../assets/moneyIcon.png';
import thunderIcon from '../../../assets/redThunder.png';
import EmptyIcon from '../../atoms/icons/EmptyIcon';

interface Props {
  data?: {
    energyHumanReadable: string;
    durationTime: string;
    incomeHumanReadable: string;
  }[];
}

const StationsTransactionsCardList: React.FC<Props> = ({ data = TRANSACTIONS }) => {
  return (
    <Div>
      <div className='header'>{T('Transactions')}</div>
      {!data?.length ? (
        <div className='empty_card'>
          <EmptyIcon size={15} className={'empty_icon'} />
          <p>{T('There are no transaction records')}</p>
        </div>
      ) : (
        data.map((transaction, index) => (
          <div className='card' key={index + 'transaction'}>
            <div className='item'>
              <img src={thunderIcon} alt='thunder icon' /> <p>{transaction.energyHumanReadable}</p>
            </div>
            <div className='item'>
              <img src={clockIcon} alt='clock icon' /> <p>{transaction.durationTime}</p>
            </div>
            <div className='item'>
              <img src={moneyIcon} alt='money icon' />
              <p>{transaction.incomeHumanReadable}</p>
            </div>
          </div>
        ))
      )}
    </Div>
  );
};

export default StationsTransactionsCardList;

const Div = styled.div`
  width: 29%;
  height: calc(100% - 10px);
  overflow-y: scroll;
  overflow-x: hidden;
  margin-left: 5px;

  .header {
    position: sticky;
    top: -1px;
    margin-top: 0;
    left: 0;
    z-index: 3;
    padding-top: 3px;
    height: 80px;
    background-image: linear-gradient(#fff, rgba(255, 255, 255, 0));
    margin-bottom: -50px;
    font-size: 12px;
    font-weight: 600;
  }

  .empty_card {
    background-color: #fff;
    box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.1);
    width: max-content;
    margin: 3px auto 3px 3px;
    border-radius: 8px;
    color: #555;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px 10px 6px 0;

    p {
      margin: 0;
      font-size: 12px;
    }

    .empty_icon {
      margin: 0 10px;
    }
  }

  .card {
    background-color: #fff;
    box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.1);
    width: calc(100% - 25px);
    margin: 3px auto 3px 3px;
    border-radius: 8px;
    color: #555;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 10px 5px 10px 10px;

    .item {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      p {
        margin: 0;
        font-size: 11px;
      }

      img {
        width: 17px;
        height: 17px;
        margin-right: 5px;
      }
    }
  }
`;
